import Script from "next/script";

export function GoiLastTouchScript() {
  // 1. 서버 사이드 환경 변수를 미리 상수로 선언 (인자 주입용)
  const API_BASE = process.env.NEXT_PUBLIC_BASE_URL || "";

  /**
   * 브라우저 런타임에서 실행될 순수 자바스크립트 로직
   */
  const trackerLogic = (apiBase: string) => {
    try {
      const COOKIE_NAME = "goi_fp_id";
      const TWO_YEARS = 60 * 60 * 24 * 365 * 2;

      const utils = {
        getCookie: (name: string) => {
          const m = document.cookie.match(
            new RegExp("(^|; )" + name + "=([^;]*)")
          );
          return m ? decodeURIComponent(m[2]) : "";
        },
        setCookie: (name: string, value: string) => {
          let s =
            name +
            "=" +
            encodeURIComponent(value) +
            "; Path=/; Max-Age=" +
            TWO_YEARS +
            "; SameSite=Lax";
          if (location.protocol === "https:") s += "; Secure";
          if (location.hostname.endsWith("goifuneral.co.kr"))
            s += "; Domain=.goifuneral.co.kr";
          document.cookie = s;
        },
        uuid: () => {
          return (
            globalThis.crypto?.randomUUID?.() ??
            Math.random().toString(36).slice(2) + Date.now().toString(36)
          );
        },
      };

      const url = new URL(location.href);
      if (url.searchParams.get("is_new_touch") === "false") return;

      /** 봇 필터 */
      const BOT_PATTERN =
        /facebookexternalhit|WhatsApp|Slackbot|Twitterbot|Googlebot|Bingbot|AhrefsBot|Applebot|LinkedInBot|Discordbot|kakaotalk-Scrap|NAVER\(.*Preview\)/i;
      if (BOT_PATTERN.test(navigator.userAgent)) return;

      let fpId = utils.getCookie(COOKIE_NAME);
      const isFirst = !fpId;
      if (isFirst) {
        fpId = utils.uuid();
        utils.setCookie(COOKIE_NAME, fpId);
      }

      const campaignKeys = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
        "utm_id",
        "gclid",
        "wbraid",
        "gbraid",
        "msclkid",
        "n_click_id",
        "nx_search_query_id",
        "k_campaign_id",
        "fbclid", // 테스트 케이스 호환
      ];
      const params: Record<string, string> = {};
      let hasCampaign = false;

      campaignKeys.forEach((k) => {
        const v = url.searchParams.get(k);
        if (v) {
          params[k] = v;
          hasCampaign = true;
        }
      });

      // 전송 조건 확인
      if (isFirst || hasCampaign) {
        // 데이터 전송
        const endpoint =
          apiBase + "/prime_last_touch/?goi_fp_id=" + encodeURIComponent(fpId);
        const body = new URLSearchParams({
          goi_fp_id: fpId,
          landing_page: location.href,
          /** 이게 안될 것 같고 */
          referrer: document.referrer || "",
          ...params,
        }).toString();

        if (navigator?.sendBeacon) {
          navigator.sendBeacon(
            endpoint,
            new Blob([body], { type: "application/x-www-form-urlencoded" })
          );
        } else {
          fetch(endpoint, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            method: "POST",
            mode: "no-cors",
            /** 백그라운드에서라도 보내라! */
            keepalive: true,
            body,
          })
            .then((response) => {
              console.log("response", response);
            })
            .catch((error) => {
              console.error("error", error);
            });
        }
      }
    } catch (err) {
      console.error("GoiTracker: Internal Error", err);
    }
  };

  return (
    <Script
      id="goi-last-touch"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        // 2. 함수 문자열 뒤에 ("값")을 붙여 브라우저에서 즉시 실행하게 만듭니다.
        __html: `(${trackerLogic.toString()})("${API_BASE}")`,
      }}
    />
  );
}
